import axios from "axios";

import { IP_RESTRICTIONS_ENGINE_BASE_URL } from "../constants";

const allowedIpRangesUrl = `${IP_RESTRICTIONS_ENGINE_BASE_URL}/allowed_ips`;

const fetch = () => axios.get(allowedIpRangesUrl);

const create = payload =>
  axios.post(allowedIpRangesUrl, { allowedIpRange: payload });

const destroy = id => axios.delete(`${allowedIpRangesUrl}/${id}`);

const update = ({ id, payload }) =>
  axios.patch(`${allowedIpRangesUrl}/${id}`, {
    allowedIpRange: payload,
  });

const allowedIpRangesApi = { fetch, create, destroy, update };

export default allowedIpRangesApi;
